// extracted by mini-css-extract-plugin
module.exports = {"pintxo-skeleton":"Skeleton_pintxo-skeleton__KVB4_","pintxo-skeleton-shape":"Skeleton_pintxo-skeleton-shape__R1__B","fill-animation":"Skeleton_fill-animation__02uQt"};